module.exports = __webpack_public_path__ + "static/media/front_squat-01.be98ad15.png";